<div class="footer">
  <div class="w-full flex justify-center px-6 items-center">
    <img
      class="w-[70%] max-w-72 fit-content"
      [src]="logo"
      alt="logo"
    />
  </div>
  <div class="legal-links">
    <a [href]="siteUrl + '/cgu/'" target="_blank">CGU</a>
    <span class="separator">·</span>
    <a [href]="siteUrl + '/politique-de-confidentialite/'" target="_blank">Politique de confidentialité</a>
  </div>
  <div class="flex justify-center rs" *ngIf="linksRS">
    <ion-button *ngIf="linksRS.facebook" fill="clear" size="small" [href]="linksRS.facebook" target="_blank"><ion-icon name="logo-facebook"></ion-icon></ion-button>
    <ion-button *ngIf="linksRS.linkedin" fill="clear" size="small" [href]="linksRS.linkedin" target="_blank"><ion-icon name="logo-linkedin"></ion-icon></ion-button>
    <ion-button *ngIf="linksRS.twitter" fill="clear" size="small" [href]="linksRS.twitter" target="_blank"><ion-icon name="logo-twitter"></ion-icon></ion-button>
    <ion-button *ngIf="linksRS.instagram" fill="clear" size="small" [href]="linksRS.instagram" target="_blank"><ion-icon name="logo-instagram"></ion-icon></ion-button>
  </div>
</div>
